import type { FC } from 'react'
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

import { YELLOW } from '~/shared/lib/theme'

/**
 * The Care Key mark, matching the icon the member app puts on a Care Key eligible provider in
 * referral search, so the same idea looks the same wherever it appears in the product.
 *
 * The two tones come from the shared `YELLOW` ramp rather than being re-pasted as hex — they are
 * the same values the app's icon uses, and reading them from the ramp keeps the two surfaces from
 * drifting apart.
 *
 * Always paired with a text label. On its own the mark reads as the app's stronger claim, "Care
 * Key Eligible", and the CRM's version of it is deliberately weaker than that.
 */
const CareKeyIcon: FC<SvgIconProps> = props => (
  <SvgIcon viewBox="0 0 16 16" data-testid="care-key-icon" {...props}>
    <path
      d="M5.11.877A2.993 2.993 0 1 1 .876 5.11 2.993 2.993 0 0 1 5.11.877ZM1.5 1.5a2.112 2.112 0 1 0 2.987 2.987A2.112 2.112 0 0 0 1.5 1.5Z"
      fill={YELLOW[500]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.61 12.591c-.907-.906-1.76-1.734-2.667-2.64-.894-.894-1.946-1.942-3.04-3.036-.26-.261-.36-.573-.395-.925V3.412a2.873 2.873 0 0 0-5.744 0v.352h-.352a2.873 2.873 0 0 0 0 5.744h2.57c.376.038.746.15 1.051.455.228.228.679.69 1.041 1.052.217.227.464.32.76.325.162.001.827-.005.997-.002.218.003.281.074.283.291 0 .11-.001.642 0 .798.007.423.295.71.716.716.143.002.609 0 .698.001.246.003.326.079.329.32.002.133 0 .652.002.784.001.139.146.396.276.522.168.163.482.482.625.625.345.345.81.41 1.066.41h1.342c.455 0 .832-.4.832-.815v-1.176c0-.695-.036-.867-.39-1.222Z"
      fill={YELLOW[500]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m3.765 3.764-.018 2.793A2.987 2.987 0 0 0 6.76 9.57l1.612-.01A1.199 1.199 0 0 0 9.56 8.371l.01-1.611a2.987 2.987 0 0 0-3.014-3.014l-2.792.018Z"
      fill={YELLOW[700]}
    />
  </SvgIcon>
)

export default CareKeyIcon
